import constants from '../constants.js';

const CommonGroupSpacer = {
  displayAs: constants.DISPLAY_AS.SPACER
};

const ProductRiskSetting1 = {
  displayName: 'Risk Processed Notification Settings',
  dataAt: 'ProductSettings.RiskSettings.ProcessedRiskEmailRecipients',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: 'The list of recipients you would like to send emails to once a risk has been processed.'
}

const CountryPnrFinishingRemarksGdsRemarksSeatRemarks = {
  displayName: 'Seat Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.SeatRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksGdsRemarksBaggageRemarks = {
  displayName: 'Baggage Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.BaggageRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions = {
  displayName: 'Finishing Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks = {
  displayName: 'Finishing Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksGdsRemarksName = {
  displayName: 'Name',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CountryPnrFinishingRemarksGdsRemarksItem = {
  displayName: 'Item',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CountryPnrFinishingRemarksGdsRemarksName, CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks, CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions, CountryPnrFinishingRemarksGdsRemarksSeatRemarks, CountryPnrFinishingRemarksGdsRemarksBaggageRemarks],
  endpoint: 'Settings',
  removeParamId: 'GdsRemarksItem',
  canDelete: true
};

const GdsSettings = {
  displayName: 'Settings',
  dataAt: 'Gds.$GdsItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'GDSSettingsOptions'
};

const GdsEnabled = {
  displayName: 'Enabled',
  dataAt: 'Gds.$GdsItem.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const GdsName = {
  displayName: 'Name',
  dataAt: 'Gds.$GdsItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const GdsPostBookingChanges = {
  displayName: 'Post Booking Changes',
  dataAt: 'Gds.$GdsItem.PostBookingChanges',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdsPostBookingChangesItem,
  gridCols:
    [{name: 'Suppliers Code', key: 'Code'}
  ]
};

const GdsPostBookingChangesSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const GdsPostBookingChangesSettings = {
  displayName: 'Settings',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'GDSSettingsOptions'
};

const GdsPostBookingChangesCountryPairs = {
  displayName: 'Country Pair',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.CountryPairs',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdsPostBookingChangesCountryPairGridItem,
  gridCols:
    [
      {
        name: 'Origins',
         key: 'Origins'
      },
      {
        name: 'Destinations',
        key: 'Destinations'
      },
      {
        name: 'Type',
        key: 'Type'
      }
    ]
};


const GdsSupplierConfiguration = {
  displayName: 'Supplier Configuration',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdsSupplierConfigurationsGridItem,
  gridCols:
    [{name: 'Suppliers', key: 'Code'}
  ]
};

const GdsSupplierConfigurationSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const GdsSupplierConfigurationSettings = {
  displayName: 'Settings',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'GDSSettingsOptions'
};

const GdsSupplierConfigurationCountryPairs = {
  displayName: 'Country Pair',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdsSupplierConfigurationCountryPairGridItem,
  gridCols:
    [
      {
        name: 'Origins',
         key: 'Origins'
      },
      {
        name: 'Destinations',
        key: 'Destinations'
      },
      {
        name: 'Type',
        key: 'Type'
      }
    ]
};

const GdsSupplierConfigurationCountryPairOrigins = {
  displayName: 'Origins',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const GdsSupplierConfigurationCountryPairDestinations = {
  displayName: 'Destinations',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const GdsSupplierConfigurationCountryPairType = {
  displayName: 'Type',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'CountryPairTypes'
};

const GdsSupplierConfigurationCountryPairGridItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    GdsSupplierConfigurationCountryPairOrigins,
    GdsSupplierConfigurationCountryPairDestinations,
    GdsSupplierConfigurationCountryPairType
  ],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'CountryPairItem',
  canDelete: true
};

const GdsSupplierConfigurationsGridItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GdsSupplierConfigurationSupplierCode, GdsSupplierConfigurationSettings, GdsSupplierConfigurationCountryPairs],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'GdsSplConfigurationItem',
  canDelete: true
};

const GdsPostBookingChangesCountryPairOrigins = {
  displayName: 'Origins',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.CountryPairs.$CountryPairItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const GdsPostBookingChangesCountryPairDestinations = {
  displayName: 'Destinations',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.CountryPairs.$CountryPairItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const GdsPostBookingChangesCountryPairType = {
  displayName: 'Type',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.CountryPairs.$CountryPairItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'CountryPairTypes'
};

const GdsPostBookingChangesCountryPairGridItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem.CountryPairs.$CountryPairItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    GdsPostBookingChangesCountryPairOrigins,
    GdsPostBookingChangesCountryPairDestinations,
    GdsPostBookingChangesCountryPairType
  ],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'CountryPairItem',
  canDelete: true
};

const GdsPostBookingChangesItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.PostBookingChanges.$GdsPBCItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GdsPostBookingChangesSupplierCode, GdsPostBookingChangesSettings, GdsPostBookingChangesCountryPairs],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'GdsPBCItem',
  canDelete: true
};

const GuestTravellersTitlesEnabled = {
  displayName: 'Enabled',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const GuestTravellersTitlesValid = {
  displayName: 'Valid',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.Valid',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const GuestTravellersTitlesIsDeleted = {
  displayName: 'Deleted',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const GuestTravellersTitlesDisplayOrder = {
  displayName: 'Display Order',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.DisplayOrder',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const GuestTravellersTitlesName = {
  displayName: 'Name',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const GuestTravellersTitlesCode = {
  displayName: 'Code',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const OptionalServiceIndustrySubCodesType = {
  displayName: 'Type',
  dataAt: 'OptionalServiceIndustrySubCodes.$optionalServiceIndustrySubCodeItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'OptionalServiceIndustryTypes'
};

const OptionalServiceIndustrySubCodesCode = {
  displayName: 'Code',
  dataAt: 'OptionalServiceIndustrySubCodes.$optionalServiceIndustrySubCodeItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const OptionalServiceIndustrySubCodesName = {
  displayName: 'Name',
  dataAt: 'OptionalServiceIndustrySubCodes.$optionalServiceIndustrySubCodeItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const OptionalServiceIndustrySubCodesDescription = {
  displayName: 'Description',
  dataAt: 'OptionalServiceIndustrySubCodes.$optionalServiceIndustrySubCodeItem.Description',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VehicleDefaultsImageUrl = {
  displayName: 'Image Url',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem.ImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'CarSupplier',
  uploadType: 'image'
};

const VehicleDefaultsTypeCode = {
  displayName: 'Type Code',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem.TypeCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VehicleDefaultsCategoryCode = {
  displayName: 'Category Code',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem.CategoryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VehicleDefaultsName = {
  displayName: 'Name',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VehicleDefaultsIsMineSpec = {
  displayName: 'Is MineSpec',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem.IsMineSpec',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TermsAndConditionsDebtorHomeCountryCode = {
  displayName: 'Debtor Home Country Code',
  dataAt: 'TermsAndConditions.$termsItem.DebtorHomeCountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const TermsAndConditionsText = {
  displayName: 'Text',
  dataAt: 'TermsAndConditions.$termsItem.Text',
  displayAs: constants.DISPLAY_AS.TEXT_AREA
};

const TermsAndConditionsSegmentTypes = {
  displayName: 'Segment Types',
  dataAt: 'TermsAndConditions.$termsItem.SegmentTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SegmentTypes'
};

const TermsAndConditionsCountries = {
  displayName: 'Countries',
  dataAt: 'TermsAndConditions.$termsItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const FlightFareDataSettings = {
  displayName: 'Settings',
  dataAt: 'FlightFareData.$flFareDataItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS
};

const FlightFareDataName = {
  displayName: 'Name',
  dataAt: 'FlightFareData.$flFareDataItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ErrorMessagesValue = {
  displayName: 'Value',
  dataAt: 'ErrorMessages.$ErMesItem.Value',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ErrorMessagesKey = {
  displayName: 'Key',
  dataAt: 'ErrorMessages.$ErMesItem.Key',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FlightFareBucketClassesFareClasses = {
  displayName: 'Fare Classes',
  dataAt: 'FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.FareClasses',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const FlightFareBucketClassesSort = {
  displayName: 'Sort',
  dataAt: 'FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Sort',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const FlightFareBucketClassesName = {
  displayName: 'Name',
  dataAt: 'FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PostBookingChangeLeadTimeOrigins = {
  displayName: 'Origins',
  dataAt: 'PostBookingLeadTimeChanges.$bkgLeadTimeItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const PostBookingChangeLeadTimeDestinations = {
  displayName: 'Destinations',
  dataAt: 'PostBookingLeadTimeChanges.$bkgLeadTimeItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const PostBookingChangeLeadTimeDuration = {
  displayName: 'Duration (minutes)',
  dataAt: 'PostBookingLeadTimeChanges.$bkgLeadTimeItem.Duration',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const NdcCountryPNRRemarkProvider = {
  displayName: 'Provider',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.Provider',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const NdcCountryPNRRemarkCountryCode = {
  displayName: 'Country Code',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const NdcCountryPNRRemarkStandardRemarks = {
  displayName: 'Standard Remarks',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.StandardRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const NdcCountryPNRRemarkGuestTravellerRemarksExclusion = {
  displayName: 'Guest Traveller Remarks Exclusion',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.GuestTravellerRemarksExclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const NdcCountryPNRRemarkGuestTravellerRemarks = {
  displayName: 'Guest Traveller Remarks',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.GuestTravellerRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const NdcCountryPNRRemarkApprovalRemarks = {
  displayName: 'Approval Remarks',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.ApprovalRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const NdcCountryPNRRemarkPostBookingChangesRemarks = {
  displayName: 'Post Booking Changes Remarks',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem.PostBookingChangesRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const NdcPccMappingProvider = {
  displayName: 'Provider',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.Provider',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const NdcPccMappingGdsPccMappingNdcPcc = {
  displayName: 'NDC PCC',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.PccMappings.$PccGdsMappingItem.NdcPcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
}

const NdcPccMappingGdsPccMappingGdsPcc = {
  displayName: 'GDS PCC',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.PccMappings.$PccGdsMappingItem.GdsPcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
}

const NdcPccMappingGdsPccMappingIataNumber = {
  displayName: 'IATA Number',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.PccMappings.$PccGdsMappingItem.IataNumber',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
}

const NdcQueueProviders = {
  displayName: 'Providers',
  dataAt: 'NdcQueues.$NdcQueueItem.Providers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const NdcQueuePcc = {
  displayName: 'Pcc',
  dataAt: 'NdcQueues.$NdcQueueItem.Pcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const NdcQueueMappingQueueID = {
  displayName: 'Queue ID',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings.$QueueMappingItem.QueueID',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
}
const NdcQueueMappingQueueName = {
  displayName: 'Queue name',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings.$QueueMappingItem.QueueName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}
const NdcQueueMappingSabrePicCode = {
  displayName: 'Sabre PIC code',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings.$QueueMappingItem.SabrePicCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}
const NdcQueueMappingDescription = {
  displayName: 'Description',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings.$QueueMappingItem.Description',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}

const NdcPccMappingGdsPccMappingGridItem = {
  displayName: 'Item',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.PccMappings.$PccGdsMappingItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    NdcPccMappingGdsPccMappingNdcPcc,
    NdcPccMappingGdsPccMappingGdsPcc,
    NdcPccMappingGdsPccMappingIataNumber
  ],
  endpoint: 'Settings',
  removeParamId: 'PccGdsMappingItem',
  canDelete: true
};

const NdcQueueMappingItem = {
  displayName: 'Item',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings.$QueueMappingItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    NdcQueueMappingQueueID,
    NdcQueueMappingQueueName,
    NdcQueueMappingSabrePicCode,
    NdcQueueMappingDescription
  ],
  endpoint: 'Settings',
  removeParamId: 'QueueMappingItem',
  canDelete: true
};

const NdcPccMappingGdsPccMappingGrid = {
  displayName: 'PCC Mapping',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem.PccMappings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NdcPccMappingGdsPccMappingGridItem,
  gridCols: [{name: 'NDC PCC', key: 'NdcPcc'}, {name: 'GDS PCC', key: 'GdsPcc'}, {name: 'IATA Number', key: 'IataNumber'}]
};

const NdcQueueMappingGrid = {
  displayName: 'Queue Mapping',
  dataAt: 'NdcQueues.$NdcQueueItem.QueueMappings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NdcQueueMappingItem,
  gridCols: [{name: 'ID', key: 'QueueID'}, {name: 'Name', key: 'QueueName'}, {name: 'Sabre PIC Code', key: 'SabrePicCode'}]
};

const CountryPnrFinishingRemarksGdsRemarksGrid = {
  displayName: 'Gds Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CountryPnrFinishingRemarksGdsRemarksItem,
  gridCols: [{name: 'Name', key: 'Name'}]
};

const CountryPnrFinishingRemarksPostBookingChangesRemarks = {
  displayName: 'Post Booking Changes Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PostBookingChangesRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks = {
  displayName: 'Expired Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions = {
  displayName: 'Expired Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks = {
  displayName: 'Declined Remarks NonRefundable Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions = {
  displayName: 'Declined Remarks NonRefundable Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks = {
  displayName: 'Declined Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions = {
  displayName: 'Declined Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks = {
  displayName: 'Approval Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions = {
  displayName: 'Approval Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks = {
  displayName: 'Guest Traveller Remarks Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions = {
  displayName: 'Guest Traveller Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks = {
  displayName: 'Pre Trip Approval Remarks Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions = {
  displayName: 'Pre Trip Approval Remarks Exclusions',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksHostCommands = {
  displayName: 'Host Commands',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.HostCommands',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks = {
  displayName: 'Standard Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.StandardRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks = {
  displayName: 'Exclusion Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.ExclusionRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingRemarksCountryCode = {
  displayName: 'Country Code',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const CountryPnrFinishingCancellationRemarks = {
  displayName: 'Cancellation Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.CancellationRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingSegmentCancellationRemarks = {
  displayName: 'Segment Cancellation Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.SegmentCancellationRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const CountryPnrFinishingAddLandSegmentPostBookingChangesRemarks = {
  displayName: 'Add Land Segments - Post Booking Changes Remarks',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem.AddLandSegmentPostBookingChangesRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const GdssettingsItem = {
  displayName: 'Gds Item',
  dataAt: 'Gds.$GdsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GdsName, GdsEnabled, GdsSettings, GdsSupplierConfiguration, GdsPostBookingChanges],
  endpoint: 'Settings',
  removeParamId: 'GdsItem',
  canDelete: true
};

const GuestTravellersTitlesGroup = {
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [GuestTravellersTitlesCode, GuestTravellersTitlesName, GuestTravellersTitlesDisplayOrder, GuestTravellersTitlesIsDeleted, GuestTravellersTitlesValid, GuestTravellersTitlesEnabled]
};

const OptionalServiceIndustrySubCodesItem = {
  displayName: 'Item',
  dataAt: 'OptionalServiceIndustrySubCodes.$optionalServiceIndustrySubCodeItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [OptionalServiceIndustrySubCodesType, OptionalServiceIndustrySubCodesCode, OptionalServiceIndustrySubCodesName, OptionalServiceIndustrySubCodesDescription],
  endpoint: 'Settings',
  removeParamId: 'optionalServiceIndustrySubCodeItem',
  canDelete: true
};

const VehicleDefaultsItem = {
  displayName: 'Item',
  dataAt: 'VehicleDefaults.$vehicleDefaultItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [VehicleDefaultsName, VehicleDefaultsCategoryCode, VehicleDefaultsTypeCode, VehicleDefaultsImageUrl, VehicleDefaultsIsMineSpec],
  endpoint: 'Settings',
  removeParamId: 'vehicleDefaultItem',
  canDelete: true
};

const TermsAndConditionsItem = {
  displayName: 'Item',
  dataAt: 'TermsAndConditions.$termsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [TermsAndConditionsCountries, TermsAndConditionsSegmentTypes, TermsAndConditionsText, TermsAndConditionsDebtorHomeCountryCode],
  endpoint: 'Settings',
  removeParamId: 'termsItem',
  canDelete: true
};

const FlightFareDataItem = {
  displayName: 'Item',
  dataAt: 'FlightFareData.$flFareDataItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightFareDataName, FlightFareDataSettings],
  endpoint: 'Settings',
  removeParamId: 'flFareDataItem',
  canDelete: true
};

const ErrorMessagesItem = {
  displayName: 'Item',
  dataAt: 'ErrorMessages.$ErMesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ErrorMessagesKey, ErrorMessagesValue],
  endpoint: 'Settings',
  removeParamId: 'ErMesItem',
  canDelete: true
};

const FlightFareBucketClassesItem = {
  displayName: 'Item',
  dataAt: 'FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightFareBucketClassesName, FlightFareBucketClassesSort, FlightFareBucketClassesFareClasses],
  endpoint: 'Settings',
  removeParamId: 'ffbcFlightFareBucketClassesItem',
  canDelete: true
};

const PostBookingChangeLeadTimeGridItem = {
  displayName: 'Item',
  dataAt: 'PostBookingLeadTimeChanges.$bkgLeadTimeItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PostBookingChangeLeadTimeOrigins, PostBookingChangeLeadTimeDestinations, PostBookingChangeLeadTimeDuration],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'bkgLeadTimeItem',
  canDelete: true
};

const NdcCountryPNRRemarkGridItem = {
  displayName: 'Item',
  dataAt: 'NdcCountryPNRRemarks.$NdcCountryPNRRemarkItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [NdcCountryPNRRemarkProvider, NdcCountryPNRRemarkCountryCode, NdcCountryPNRRemarkStandardRemarks, NdcCountryPNRRemarkGuestTravellerRemarksExclusion, NdcCountryPNRRemarkGuestTravellerRemarks, NdcCountryPNRRemarkApprovalRemarks, NdcCountryPNRRemarkPostBookingChangesRemarks],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'NdcCountryPNRRemarkItem',
  canDelete: true
};

const NdcPccMappingGridItem = {
  displayName: 'Item',
  dataAt: 'NdcPccMappings.$NdcPccMappingItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [NdcPccMappingProvider, NdcPccMappingGdsPccMappingGrid],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'NdcPccMappingItem',
  canDelete: true
};

const NdcQueueGridItem = {
  displayName: 'Item',
  dataAt: 'NdcQueues.$NdcQueueItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [NdcQueueProviders, NdcQueuePcc, NdcQueueMappingGrid],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'NdcQueueItem',
  canDelete: true
};

const CountryPnrFinishingRemarksGridItem = {
  displayName: 'Country PNR Finishing Remark',
  dataAt: 'CountryPnrFinishingRemarks.$CntPnrFinRemItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CountryPnrFinishingRemarksCountryCode, CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks, CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks, CountryPnrFinishingRemarksHostCommands, CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions, CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks, CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions, CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks, CountryPnrFinishingRemarksPostBookingChangesRemarks, CountryPnrFinishingRemarksGdsRemarksGrid, CountryPnrFinishingCancellationRemarks, CountryPnrFinishingSegmentCancellationRemarks, CountryPnrFinishingAddLandSegmentPostBookingChangesRemarks],
  endpoint: 'Settings',
  routeParamId: '',
  removeParamId: 'CntPnrFinRemItem',
  canDelete: true
};

const Gdssettings = {
  displayName: 'Gds',
  dataAt: 'Gds',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdssettingsItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Enabled', key: 'Enabled'}]
};

const PnrFinishingRemarksPanelStandardRemarks = {
  displayName: 'Standard Remarks',
  dataAt: 'PnrFinishingRemarks.StandardRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const PnrFinishingRemarksPanelPreTripApprovalRemarks = {
  displayName: 'Pre Trip Approval Remarks',
  dataAt: 'PnrFinishingRemarks.PreTripApprovalRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const PnrFinishingRemarksPanelPreTripApprovalExclusions = {
  displayName: 'Pre Trip Approval Exclusions',
  dataAt: 'PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const PnrFinishingRemarksPanelGuestTravellerRemarks = {
  displayName: 'Guest Traveller Remarks',
  dataAt: 'PnrFinishingRemarks.GuestTravellerRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const PnrFinishingRemarksPanelGuestTravellerExclusions = {
  displayName: 'Guest Traveller Exclusion Remarks',
  dataAt: 'PnrFinishingRemarks.GuestTravellerRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const GuestTravellersTitlesGridItem = {
  displayName: 'Guest Travellers Title',
  dataAt: 'GuestTravellersTitles.$gusTravTitleItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GuestTravellersTitlesGroup],
  endpoint: 'Settings',
  removeParamId: 'gusTravTitleItem',
  canDelete: true
};

const AdditionalPnrRemarksExpiredRemarks = {
  displayName: 'Expired Remarks',
  dataAt: 'AdditionalPnrRemarks.ExpiredRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const AdditionalPnrRemarksDeclinedRemarksNonRefundable = {
  displayName: 'Declined Remarks Non-refundable',
  dataAt: 'AdditionalPnrRemarks.DeclinedRemarksNonRefundable',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const AdditionalPnrRemarksDeclinedRemarks = {
  displayName: 'Declined Remarks',
  dataAt: 'AdditionalPnrRemarks.DeclinedRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const AdditionalPnrRemarksApprovalRemarks = {
  displayName: 'Approval Remarks',
  dataAt: 'AdditionalPnrRemarks.ApprovalRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const OptionalServiceIndustrySubCodesGrid = {
  displayName: 'Optional Services Industry Sub Codes',
  dataAt: 'OptionalServiceIndustrySubCodes',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: OptionalServiceIndustrySubCodesItem,
  gridCols:
    [
      {name: 'Type', key: 'Type'},
      {name: 'Code', key: 'Code'},
      {name: 'Description', key: 'Description'}
    ]
};

const VehicleDefaultsGrid = {
  displayName: 'Vehicle Defaults',
  dataAt: 'VehicleDefaults',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: VehicleDefaultsItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Category Code', key: 'CategoryCode'},
      {name: 'Type Code', key: 'TypeCode'}]
};

const TermsAndConditionsGrid = {
  displayName: 'Terms & Condition',
  dataAt: 'TermsAndConditions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: TermsAndConditionsItem,
  gridCols:
    [{name: 'Countries', key: 'Countries'},
      {name: 'SegmentTypes', key: 'SegmentTypes'}]
};

const FlightFareDataGrid = {
  displayName: 'Flight Fare Data',
  dataAt: 'FlightFareData',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightFareDataItem,
  gridCols: [{name: 'Name', key: 'Name'}]
};

const DefaultFareRules = {
  displayName: 'Default Fare Rules',
  dataAt: 'DefaultFareRules',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ErrorMessagesGrid = {
  displayName: 'Error Messages',
  dataAt: 'ErrorMessages',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ErrorMessagesItem,
  gridCols: [{name: 'Key', key: 'Key'}]
};

const MinimumHotelRating = {
  displayName: 'Minimum Hotel Rating',
  dataAt: 'MinimumHotelRating',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 0,
  max: 4
};

const SettingsRadiusDistance = {
  displayName: 'Hotel Radius Distance',
  dataAt: 'RadiusDistance',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 0,
  max: 9999999999
};

const LimitCountries = {
  displayName: 'Limit Countries',
  dataAt: 'LimitCountries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const BeamerEnabled = {
  displayName: 'Enable Beamer',
  dataAt: 'BeamerFeature',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable Lightning Beamer feature globally'
};

const BeamerSettingsGroup = {
  displayName: 'Global Beamer Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    BeamerEnabled,
    CommonGroupSpacer],
  helpText: 'Global level Beamer config'
};

const FlightFareBucketClassesGrid = {
  displayName: 'Flight Fare Bucket Data',
  dataAt: 'FlightFareBucketClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightFareBucketClassesItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Classes', key: 'FareClasses'},
      {name: 'Sort', key: 'Sort'}]
};

const FlightFareClasses = {
  displayName: 'Flight Fare Classes',
  dataAt: 'FlightFareClasses',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const Id = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PostBookingChangeLeadTimeGrid = {
  displayName: 'Post Booking Changes Lead Time',
  dataAt: 'PostBookingLeadTimeChanges',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PostBookingChangeLeadTimeGridItem,
  gridCols: [{name: 'Origins', key: 'Origins'}, {name: 'Destinations', key: 'Destinations'}, {name: 'Duration', key: 'Duration'}]
};

const ChangesPostBookingPanel = {
  tabName: 'Post-Booking-Changes',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [PostBookingChangeLeadTimeGrid]
};

const NdcCountryPNRRemarkGrid = {
  displayName: 'NDC Country PNR Remarks',
  dataAt: 'NdcCountryPNRRemarks',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NdcCountryPNRRemarkGridItem,
  gridCols: [{name: 'Country Code', key: 'CountryCode'}, {name: 'Provider', key: 'Provider'}]
};

const NdcPccMappingGrid = {
  displayName: 'NDC PCC Mapping',
  dataAt: 'NdcPccMappings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NdcPccMappingGridItem,
  gridCols: [{name: 'Provider', key: 'Provider'}]
};

const NdcQueueGrid = {
  displayName: 'NDC Queue',
  dataAt: 'NdcQueues',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NdcQueueGridItem,
  gridCols: [{name: 'Providers', key: 'Providers'}, {name: 'Pcc', key: 'Pcc'}]
};

const NdcSettingsPanel = {
  tabName: 'NDC-Settings',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [NdcQueueGrid, NdcPccMappingGrid, NdcCountryPNRRemarkGrid]
};

const CountryPnrFinishingRemarksGrid = {
  tabName: 'Country-PNR-Remarks',
  displayName: 'Country PNR Remarks',
  dataAt: 'CountryPnrFinishingRemarks',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CountryPnrFinishingRemarksGridItem,
  gridCols: [{name: 'Country Code', key: 'CountryCode'}]
};

const SettingsGDSPanel = {
  dataAt: '',
  tabName: 'GDS',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [Gdssettings]
};

const PnrFinishingRemarksPanel = {
  tabName: 'PNR-Finishing-Remarks',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: 'PnrFinishingRemarks',
  children: [PnrFinishingRemarksPanelGuestTravellerExclusions, PnrFinishingRemarksPanelGuestTravellerRemarks, PnrFinishingRemarksPanelPreTripApprovalExclusions, PnrFinishingRemarksPanelPreTripApprovalRemarks, PnrFinishingRemarksPanelStandardRemarks]
};

const GuestTravellersTitlesPanel = {
  tabName: 'Guest-Travellers-Titles',
  displayName: 'Guest Travellers Titles',
  dataAt: 'GuestTravellersTitles',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GuestTravellersTitlesGridItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Code', key: 'Code'},
      {name: 'Display Order', key: 'DisplayOrder'}]
};

const AdditionalPnrRemarksPanel = {
  tabName: 'Additional-PNR-Remarks',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [AdditionalPnrRemarksApprovalRemarks, AdditionalPnrRemarksDeclinedRemarks, AdditionalPnrRemarksDeclinedRemarksNonRefundable, AdditionalPnrRemarksExpiredRemarks]
};

const RiskSettingsGroup = {
  displayName: 'Risk Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [ CommonGroupSpacer, ProductRiskSetting1 ]
};

const ProductSettingsPanel = {
  tabName: 'Product-Settings',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ RiskSettingsGroup ]
};

const SettingsMiscPanel = {
  tabName: 'Settings-Misc',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [Id, FlightFareClasses, FlightFareBucketClassesGrid, BeamerSettingsGroup, LimitCountries, SettingsRadiusDistance, MinimumHotelRating, ErrorMessagesGrid, DefaultFareRules, FlightFareDataGrid, TermsAndConditionsGrid, VehicleDefaultsGrid, OptionalServiceIndustrySubCodesGrid]
};

const SettingsTabs = {
  displayName: 'Settings',
  iconClass: 'fa-cog',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [SettingsMiscPanel, AdditionalPnrRemarksPanel, GuestTravellersTitlesPanel, PnrFinishingRemarksPanel, SettingsGDSPanel, CountryPnrFinishingRemarksGrid, NdcSettingsPanel, ChangesPostBookingPanel, ProductSettingsPanel]
};

const SettingsResource = {
  rootNode: true,
  displayName: 'Settings',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: 'fa-cog',
  dataAt: '',
  children: [ SettingsTabs ],
  endpoint: 'Settings'
};

export default {
  SettingsResource,
  SettingsTabs,
  SettingsMiscPanel,
  AdditionalPnrRemarksPanel,
  GuestTravellersTitlesPanel,
  PnrFinishingRemarksPanel,
  SettingsGDSPanel,
  CountryPnrFinishingRemarksGrid,
  NdcSettingsPanel,
  Id,
  FlightFareClasses,
  FlightFareBucketClassesGrid,
  LimitCountries,
  BeamerSettingsGroup,
  SettingsRadiusDistance,
  MinimumHotelRating,
  ErrorMessagesGrid,
  DefaultFareRules,
  FlightFareDataGrid,
  TermsAndConditionsGrid,
  VehicleDefaultsGrid,
  OptionalServiceIndustrySubCodesGrid,
  AdditionalPnrRemarksApprovalRemarks,
  AdditionalPnrRemarksDeclinedRemarks,
  AdditionalPnrRemarksDeclinedRemarksNonRefundable,
  AdditionalPnrRemarksExpiredRemarks,
  GuestTravellersTitlesGridItem,
  PnrFinishingRemarksPanelGuestTravellerExclusions,
  PnrFinishingRemarksPanelGuestTravellerRemarks,
  PnrFinishingRemarksPanelPreTripApprovalExclusions,
  PnrFinishingRemarksPanelPreTripApprovalRemarks,
  PnrFinishingRemarksPanelStandardRemarks,
  Gdssettings,
  CountryPnrFinishingRemarksGridItem,
  FlightFareBucketClassesItem,
  ErrorMessagesItem,
  FlightFareDataItem,
  TermsAndConditionsItem,
  VehicleDefaultsItem,
  OptionalServiceIndustrySubCodesItem,
  GuestTravellersTitlesGroup,
  GdssettingsItem,
  CountryPnrFinishingRemarksCountryCode,
  CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks,
  CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks,
  CountryPnrFinishingRemarksHostCommands,
  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions,
  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks,
  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions,
  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks,
  CountryPnrFinishingRemarksPostBookingChangesRemarks,
  CountryPnrFinishingRemarksGdsRemarksGrid,
  CountryPnrFinishingCancellationRemarks,
  CountryPnrFinishingSegmentCancellationRemarks,
  CountryPnrFinishingAddLandSegmentPostBookingChangesRemarks,
  FlightFareBucketClassesName,
  FlightFareBucketClassesSort,
  FlightFareBucketClassesFareClasses,
  ErrorMessagesKey,
  ErrorMessagesValue,
  FlightFareDataName,
  FlightFareDataSettings,
  TermsAndConditionsCountries,
  TermsAndConditionsSegmentTypes,
  TermsAndConditionsText,
  TermsAndConditionsDebtorHomeCountryCode,
  VehicleDefaultsName,
  VehicleDefaultsCategoryCode,
  VehicleDefaultsTypeCode,
  VehicleDefaultsImageUrl,
  OptionalServiceIndustrySubCodesType,
  OptionalServiceIndustrySubCodesCode,
  OptionalServiceIndustrySubCodesDescription,
  OptionalServiceIndustrySubCodesName,
  GuestTravellersTitlesCode,
  GuestTravellersTitlesName,
  GuestTravellersTitlesDisplayOrder,
  GuestTravellersTitlesIsDeleted,
  GuestTravellersTitlesValid,
  GuestTravellersTitlesEnabled,
  GdsName,
  GdsEnabled,
  GdsSettings,
  GdsSupplierConfiguration,
  GdsSupplierConfigurationsGridItem,
  GdsSupplierConfigurationSupplierCode,
  GdsSupplierConfigurationSettings,
  GdsSupplierConfigurationCountryPairs,
  GdsSupplierConfigurationCountryPairGridItem,
  GdsSupplierConfigurationCountryPairOrigins,
  GdsSupplierConfigurationCountryPairDestinations,
  GdsSupplierConfigurationCountryPairType,
  GdsPostBookingChanges,
  GdsPostBookingChangesItem,
  GdsPostBookingChangesSupplierCode,
  GdsPostBookingChangesSettings,
  GdsPostBookingChangesCountryPairs,
  GdsPostBookingChangesCountryPairGridItem,
  GdsPostBookingChangesCountryPairOrigins,
  GdsPostBookingChangesCountryPairDestinations,
  GdsPostBookingChangesCountryPairType,
  CountryPnrFinishingRemarksGdsRemarksItem,
  CountryPnrFinishingRemarksGdsRemarksName,
  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks,
  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions,
  CountryPnrFinishingRemarksGdsRemarksSeatRemarks,
  CountryPnrFinishingRemarksGdsRemarksBaggageRemarks,
  NdcQueueGridItem,
  NdcQueuePcc,
  NdcQueueProviders,
  NdcQueueMappingGrid,
  NdcQueueMappingItem,
  NdcQueueMappingQueueID,
  NdcQueueMappingQueueName,
  NdcQueueMappingSabrePicCode,
  NdcQueueMappingDescription,
  NdcQueueGrid,
  NdcPccMappingGrid,
  NdcPccMappingGridItem,
  NdcPccMappingProvider,
  NdcPccMappingGdsPccMappingGrid,
  NdcPccMappingGdsPccMappingGridItem,
  NdcPccMappingGdsPccMappingNdcPcc,
  NdcPccMappingGdsPccMappingGdsPcc,
  NdcPccMappingGdsPccMappingIataNumber,
  NdcCountryPNRRemarkGrid,
  NdcCountryPNRRemarkGridItem,
  NdcCountryPNRRemarkProvider, 
  NdcCountryPNRRemarkCountryCode, 
  NdcCountryPNRRemarkStandardRemarks, 
  NdcCountryPNRRemarkGuestTravellerRemarksExclusion, 
  NdcCountryPNRRemarkGuestTravellerRemarks, 
  NdcCountryPNRRemarkApprovalRemarks,
  NdcCountryPNRRemarkPostBookingChangesRemarks,
  ChangesPostBookingPanel,
  PostBookingChangeLeadTimeGrid,
  PostBookingChangeLeadTimeGridItem,
  PostBookingChangeLeadTimeOrigins,
  PostBookingChangeLeadTimeDestinations,
  PostBookingChangeLeadTimeDuration,
  ProductSettingsPanel,
  RiskSettingsGroup,
  ProductRiskSetting1,
  CommonGroupSpacer
}



// WEBPACK FOOTER //
// ./src/config/fields/settingsResource.js